<app-capture-history-item-title>
  {{ title }}
</app-capture-history-item-title>

<app-capture-history-item-body>
  <p>
    {{ description }}
  </p>

  @if (claimType) {
    <p>
      Claim Type: {{ claimType }}
    </p>
  }

  @if (matchConfidence) {
    <p>
      Confidence Ratio: {{ matchConfidence }}
    </p>
  }

  @if (nameFieldsReversed) {
    <p>
      Matched with the patient's first and last name fields reversed
    </p>
  }
</app-capture-history-item-body>
